import { defineComponent as n, createBlock as s, openBlock as i, unref as a, withCtx as e, renderSlot as r } from "vue";
import { createWorkspaceStore as f } from "@scalar/workspace-store/client";
import p from "../v2/ApiReferenceWorkspace.vue.js";
import "../v2/ApiReferenceWorkspace.vue2.js";
const _ = /* @__PURE__ */ n({
  __name: "ApiReference",
  props: {
    configuration: {}
  },
  setup(c) {
    const t = f();
    return typeof window < "u" && (window.dataDumpWorkspace = () => t), (o, d) => (i(), s(p, {
      configuration: o.configuration,
      store: a(t)
    }, {
      footer: e(() => [
        r(o.$slots, "footer")
      ]),
      "content-end": e(() => [
        r(o.$slots, "content-end")
      ]),
      "sidebar-start": e(() => [
        r(o.$slots, "sidebar-start")
      ]),
      "sidebar-end": e(() => [
        r(o.$slots, "sidebar-end")
      ]),
      _: 3
    }, 8, ["configuration", "store"]));
  }
});
export {
  _ as default
};
